import { render, staticRenderFns } from "./QaQuestionContentAnswer.vue?vue&type=template&id=36b971c4&scoped=true&"
import script from "@/scripts/QA/Question/components/QaQuestionContentAnswer?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/QaQuestionContentAnswer?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b971c4",
  null
  
)

export default component.exports